import WebService from "../WebService";
import axios from "axios";

import { webApiDomain } from "../../utils/Constants";
const Auth = {
  register(data) {
    const url = `${webApiDomain}/auth/register`;
    return axios.post(url, data);
  },
  login({ email, password, redirect }) {
    const url = `${webApiDomain}/auth/login`;
    const data = {
      email: email,
      password: password,
      redirect: redirect ? true : null
    };
    return axios.post(url, data);
  },
  getCheckinToken() {
    return WebService.get(`${webApiDomain}/checkin/get-redirect-token`);
  },
  getUser() {
    return WebService.get("/user/me");
  },
  getNavMenus(e, s) {
    return WebService.get("/my/nav-menus?e=" + e + "&s=" + s);
  },
  getMySellers() {
    return WebService.get("/my/sellers");
  },
  updateProfile(data) {
    return WebService.post("/user/profile", data);
  }
};
export default Auth;
